export enum SwapVehicleType {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
}
